<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
    <el-form-item label="短信内容">
      <el-input
        type="textarea"
        v-model="ruleForm.smsContent"
        style="width: 79rem"
      ></el-input>
    </el-form-item>
    <el-form-item label="选择接收短信人员" style="margin-top: 2.2rem">
      <div
        class="bgcolor"
        style="display: inline-block; width: 79rem; height: 37.3rem"
      >
        <UserTabControl
          @loading="showLoading"
          @loadingFinish="hideLoading"
          ref="userTabls"
          :form="form"
        ></UserTabControl>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import MyApis from "../../../apis";
import UserTabControl from "./UserTabControl";
export default {
  name: "ZjComponentSMSDetail",
  controller: "UI",
  action: "ComponentSMSDetail",
  components: {
    UserTabControl,
  },
  props: {
    PlanTaskId: String,
    TaskSubTypeId: String,
    form:String
  },
  data() {
    return {
      ruleForm: {
        smsContent: "",
      },
    };
  },
  created: function () {
    if(this.form && this.form.sms){
      this.ruleForm.smsContent = this.form.sms.smsContent
    }
  },
  methods: {
    showLoading(text) {
      this.$emit("loading", text);
    },
    hideLoading() {
      this.$emit("loadingFinish");
    },
    Gettaskreceiver() {
      var chil = this.$refs["userTabls"];
      return {
        ...this.ruleForm,
        personList: chil.GetCheckedUserItems()
      }
    },
  },
  watch:{
    'form.sms':{
       handler(val, oldVal) {
        if (val) {
          this.ruleForm = val
        }
      },
      deep: true,
      immediate: true,
    }
  }
};
</script>